import axios from "axios";
import { BACKEND_API } from "../../services/helper";
import { SET_MESSAGE } from "../Types/contactTypes";

export const contactAction = (postData) => {
    return async (dispatch) => {
        try
        {
            const { data } = await axios.post(`${BACKEND_API}/contact`, postData);
            dispatch({ type : SET_MESSAGE, payload : data.msg });
        }
        catch(error)
        {
            console.log(error);
        }
    }
}